import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  fab: {
    position: 'fixed',
    bottom: 74,
    right: 24,
    width: 56,
    height: 56,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: theme.shadows[6],
    zIndex: 1300,
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: theme.shadows[8],
    },
    '& svg': {
      fontSize: 28,
    },
  },
  chatPanel: {
    position: 'fixed',
    bottom: 74,
    right: 24,
    width: 360,
    height: 480,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 12,
    overflow: 'hidden',
    zIndex: 1300,
  },
  chatHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  chatTitle: {
    fontWeight: 600,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
  messagesContainer: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default,
  },
  emptyHint: {
    alignSelf: 'center',
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  messageUser: {
    alignSelf: 'flex-end',
    maxWidth: '85%',
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    borderBottomRightRadius: 4,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  messageAssistant: {
    alignSelf: 'flex-start',
    maxWidth: '85%',
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    borderBottomLeftRadius: 4,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
  },
  inputContainer: {
    padding: theme.spacing(1.5, 2),
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  inputWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
  },
  input: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },
  },
  sendButton: {
    flexShrink: 0,
    alignSelf: 'flex-end',
    marginBottom: 4,
  },
}));
